import {useEffect} from 'react';
import {useBackend} from 'state/backend';
import {DownloadObjectItem} from './types';

const INTERVAL_DURATION = 5000;
const hasPendingDownloads = (objectList: DownloadObjectItem[]) =>
    objectList.some((item) => item.status === 'new');

const useObjectListRefresh = (objectList: DownloadObjectItem[]) => {
    const {isRefreshing, refreshData} = useBackend();
    const shouldRefresh = hasPendingDownloads(objectList);
    useEffect(() => {
        if (!shouldRefresh) return;
        const interval = setInterval(async () => {
            if (isRefreshing) return;

            if (shouldRefresh) {
                await refreshData(window.Urls.async_download_view());
            } else {
                clearInterval(interval);
            }
        }, INTERVAL_DURATION);

        return () => {
            clearInterval(interval);
        };
    });
};

export default useObjectListRefresh;
